const MtrEyeOutline={
    "name": "mtr-eye",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                }
            },
            {
                "tag": "circle",
                "attrs": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    }
};
export default MtrEyeOutline;